"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SellerType = exports.ChannelType = exports.OrderStatus = exports.OrderEventType = void 0;
var OrderEventType;
(function (OrderEventType) {
    OrderEventType["NEW_ORDER"] = "new_order";
    OrderEventType["NEW_QUOTE"] = "new_quote";
    OrderEventType["NEW_QUOTE_ACCEPTED"] = "new_quote_accepted";
    OrderEventType["NEW_QUOTE_REFUSED"] = "new_quote_refused";
    OrderEventType["NEW_QUOTE_ACTION_NEEDED"] = "new_quote_action_needed";
    OrderEventType["LOOKING_TRADER"] = "looking_trader";
    OrderEventType["TRADER_FOUND"] = "trader_found";
    OrderEventType["TRADER_HAS_CANCELED"] = "trader_has_canceled";
    OrderEventType["NO_TRADER"] = "no_trader";
    OrderEventType["JOB_PLANNED"] = "job_planned";
    OrderEventType["TRADER_START_MOVING"] = "trader_start_moving";
    OrderEventType["JOB_IN_PROGRESS"] = "job_in_progress";
    OrderEventType["JOB_DONE"] = "job_done";
    OrderEventType["ORDER_WAITING_PAYMENT"] = "order_waiting_payment";
    OrderEventType["ORDER_PROCESSING_PAYMENT"] = "order_processing_payment";
    OrderEventType["ORDER_DONE_PAID"] = "order_done_paid";
    OrderEventType["ORDER_CANCELED"] = "order_canceled";
    OrderEventType["ORDER_CANCELED_FEES"] = "order_canceled_fees";
    OrderEventType["ORDER_REFUND"] = "order_refund";
    OrderEventType["REVIEW_TRADER"] = "review_trader";
    OrderEventType["NEW_INVOICE"] = "new_invoice";
    OrderEventType["TO_DISPATCH_MANUALLY"] = "to_dispatch_manually";
    OrderEventType["TRADER_EMAIL_SENT"] = "trader_email_sent";
    OrderEventType["ALMA_TRANSACTION_REFUSED"] = "alma_transaction_refused";
    OrderEventType["PAYMENT_TRANSACTION_FAILED"] = "payment_transaction_failed";
    OrderEventType["ORDER_WAITING_ALMA"] = "order_waiting_alma";
})(OrderEventType = exports.OrderEventType || (exports.OrderEventType = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["NEW"] = "new";
    OrderStatus["IN_PROGRESS"] = "in_progress";
    OrderStatus["INCOMPLETE_NEED_TERMS"] = "incomplete_need_terms";
    OrderStatus["INCOMPLETE_WAITING_CONFIRM"] = "incomplete_waiting_confirm";
    OrderStatus["NEW_QUOTE"] = "new_quote";
    OrderStatus["NEW_QUOTE_ACTION_NEEDED"] = "new_quote_action_needed";
    OrderStatus["CANCELED"] = "canceled";
    OrderStatus["CANCELED_FEES"] = "canceled_fees";
    OrderStatus["CANCELED_FEES_WAITING_PAYMENT"] = "canceled_fees_waiting_payment";
    OrderStatus["CANCELED_FEES_PAID"] = "canceled_fees_paid";
    OrderStatus["DONE_PAID"] = "done_paid";
    OrderStatus["DONE_UNPAID"] = "done_unpaid";
    OrderStatus["DONE_PAYMENT_FAILED"] = "done_payment_failed";
    OrderStatus["DONE_WAITING_PAYMENT"] = "done_waiting_payment";
    OrderStatus["DONE_PROCESSING_PAYMENT"] = "done_processing_payment";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var ChannelType;
(function (ChannelType) {
    ChannelType["WEB"] = "web";
    ChannelType["CALL_CENTER"] = "call_center";
})(ChannelType = exports.ChannelType || (exports.ChannelType = {}));
var SellerType;
(function (SellerType) {
    SellerType["DELIVERY"] = "delivery";
    SellerType["STORE"] = "store";
    SellerType["REPUDIATION"] = "repudiation";
})(SellerType = exports.SellerType || (exports.SellerType = {}));
//# sourceMappingURL=order.js.map